module.exports = __webpack_public_path__ + "static/media/sort-default.1d5ae217.svg";